import InfoTooltip from "#/components/ui/InfoTooltip";
import { usePrvTranslation } from "./usePrvTranslation";

const TERMS = [
  "onSiteNow",
  "arrivals",
  "departures",
  "rate",
  "avgTime",
  "lastActivity",
  "heatmapValue",
  "onSiteLine",
  "target",
] as const;

/** "?" button whose popover defines every number shown in the patterns panel. */
interface Props {
  /** False when the heatmap section is not rendered (single sub-client view). */
  showHeatmap?: boolean;
}

const PrvGlossary = ({ showHeatmap = true }: Props) => {
  const t = usePrvTranslation();

  return (
    <div className="flex items-center gap-2 text-xs text-gray-600">
      <span>{t("clients.prv.results.glossary.title")}</span>
      <InfoTooltip
        content={
          <dl className="flex flex-col gap-2 text-xs">
            {TERMS.filter((term) => showHeatmap || term !== "heatmapValue").map((term) => (
              <div key={term}>
                <dt className="font-semibold text-gray-900">
                  {t(`clients.prv.results.glossary.${term}.label`)}
                </dt>
                <dd className="text-gray-600">{t(`clients.prv.results.glossary.${term}.text`)}</dd>
              </div>
            ))}
          </dl>
        }
      />
    </div>
  );
};

export default PrvGlossary;
